import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./process.css";
import { useEffect, useRef,useState } from "react";


// Import images
import process1 from "../../assets/images/Process/step1.jpg";
import process2 from "../../assets/images/Process/step2.jpg";
import process3 from "../../assets/images/Process/step3.jpg";
import process4 from "../../assets/images/Process/step4.jpg";
import process5 from "../../assets/images/Process/step5.jpg";
import process6 from "../../assets/images/Process/step6.jpg";
import process7 from "../../assets/images/Process/step7.jpg";
import process8 from "../../assets/images/Process/step8.jpg";
import process9 from "../../assets/images/Process/step9.jpg";

//shape of image all
import bg from "../../assets/images/Process/bg-history.png";
import { color } from "framer-motion";

const processSteps = [
    { image: process1, year: "Step 1", color:"#F78B8B", heading: "Client Consultation", text: "At the heart of our work process is a thorough understanding of our clients’ needs. Through in-depth consultations, we aim to comprehend their business objectives, challenges, and expectations." },
    { image: process2, year: "Step 2",color:"#D83E3E", heading: "Project Planning", text: "With a clear understanding of the client’s requirements, we embark on meticulous project planning. This involves defining the project scope, setting realistic timelines, and establishing achievable milestones." },
    { image: process3, year: "Step 3",color:"#C20B0B", heading: "Design and Prototyping", text: "Our creative journey begins with designing and prototyping. Our skilled designers translate concepts into visual representations, creating wireframes and design concepts." },
    { image: process4, year: "Step 4", color:"#720B0B",heading: "Development", text: "The development phase is where ideas transform into functional solutions. Our experienced developers, utilizing the latest technologies, write code to bring the design to life." },
    { image: process5, year: "Step 5",color:"#720B0B", heading: "Quality Assurance (QA) and Testing", text: "We are committed to delivering products of the highest quality. Our QA team rigorously tests the developed solutions, identifying and rectifying any issues." },
    { image: process6, year: "Step 6",color:"#4C0C0C", heading: "Client Review and Feedback", text: "Collaboration with our clients is continuous, and their input is invaluable. We present the developed solution for client review, encouraging feedback and modifications." },
    { image: process7, year: "Step 7",color:"#4C0C0C", heading: "Deployment", text: "The deployment phase marks the transition from development to the live environment." },
    { image: process8, year: "Step 8",color:"#4C0C0C", heading: "Maintenance and Support", text: "Our relationship extends beyond project completion. We provide ongoing maintenance and support, addressing any post-launch issues promptly." },
    { image: process9, year: "Step 9",color:"#4C0C0C", heading: "Project Closure and Evaluation", text: "The completion of a project is not the end but a transition to evaluation and continuous improvement." },
];
// Left arrow (Prev)
const PrevArrow = ({ onClick }) => (
    <div className="custom-arrow prev" onClick={onClick}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </div>
);

// Right arrow (Next)
const NextArrow = ({ onClick }) => (
    <div className="custom-arrow next" onClick={onClick}>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6 4L10 8L6 12" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
    </div>
);

const Process = () => {

const sliderRef = useRef(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Determine slidesToShow based on width
  const getSlidesToShow = () => {
    if (windowWidth <= 480) return 1;
    if (windowWidth <= 768) return 2;
    if (windowWidth <= 1024) return 3;
    return 4;
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: getSlidesToShow(),
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  };

    
    return (
        <section className="process-one">
            
            <div className="auto-container">
                <div className="sec-title2 centered">
                    <h2 className="sec-title_heading">Our Work Process</h2>
                </div>
                <div className="process-one_inner-container">
                    {/* Horizontal line */}
                    <div className="timeline-line" />

                    <Slider ref={sliderRef} {...settings}>
                        {processSteps.map((step, index) => (
                            <div key={index} className="process-one_block">
                                <div className="process-one_block-inner">
                                    <div className="process-one_image">
                                        <div
                                            className="process-one_image marker-wrapper"
                                            style={{ width: 120, height: 120 }}
                                        >
                                            <div className="marker">
                                                <img src={step.image} alt={step.heading} className="process-img" />
                                            </div>
                                        </div>

                                    </div>

                                    <div className="process-one_year"  style={{ "--year-color": step.color }}>{step.year}</div>
                                    <h5 className="process-one_heading">{step.heading}</h5>
                                    <div className="process-one_text">{step.text}</div>
                                </div>
                            </div>
                        ))}
                    </Slider>

                    {/* Custom dots */}
                    <div className="timeline-dots">
                        {processSteps.map((_, index) => (
                            <div key={index} className="dot"></div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Process;
